<template>
  <div>
    <router-link
      v-for="project in projects"
      :key="project.id"
      :to="{ name: 'project', params: { id: project.id }}"
      class="block p-2 pl-4 rounded bg-blue-500 text-white mb-2">
      {{ project.data().branch }}
    </router-link>
  </div>
</template>

<script>
  import firebase from 'firebase'

  export default {
    data () {
      return {
        projects: [],
        newDocumentModal: false
      }
    },

    computed: {
      projetsCollection () {
        return firebase.firestore().collection('projects')
      }
    },

    mounted () {
      this.projetsCollection.onSnapshot(querySnapshot => {
        this.projects = querySnapshot.docs
      })
    }
  }
</script>
